import React from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";

interface Announcement {
  ID: number;
  announcement: string;
  featured: "0" | "1";
  modified_by: string;
  created_date: string;
  modified_date: string;
}

interface AnnouncementResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: Announcement[];
}

const Announcements: React.FC = () => {
  const {
    data: announcementResponse,
    loading: announcementLoading,
    error: announcementError,
  } = useApi<AnnouncementResponse>("/api/get-announcement", {
    method: "GET",
    autoCall: true,
  });

  // Table Columns
  const announcementColumns = [
    {
      title: "SNo.",
      dataIndex: "key",
    },
    {
      title: "Announcement",
      dataIndex: "announcement",
      render: (text: string) => (
        <div
          style={{ maxWidth: "400px" }}
          dangerouslySetInnerHTML={{
            __html:
              text.length > 150 ? text.substring(0, 150) + "..." : text,
          }}
        />
      ),
    },
    {
      title: "Featured",
      dataIndex: "featured",
      render: (value: string) =>
        value === "1" ? (
          <span className="badge bg-success">Yes</span>
        ) : (
          <span className="badge bg-secondary">No</span>
        ),
    },
    {
      title: "Created By",
      dataIndex: "modified_by",
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      render: (date: string) => {
        const d = new Date(date);
        return d.toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });
      },
    },
  ];

  const tableData = (announcementResponse?.data || []).map(
    (item, index) => ({
      ...item,
      key: index + 1,
    })
  );

  return (
    <>
      <Loader loading={announcementLoading} />

      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Announcements</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Communication</li>
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                  >
                    Announcements
                  </li>
                </ol>
              </nav>
            </div>

            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>

          {/* Table Card */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h5 className="mb-0">Announcements List</h5>
            </div>

            <div className="card-body">
              <div className="card table-responsive">
                <Table
                  dataSource={tableData}
                  columns={announcementColumns}
                  Selection={false}
                  showSearchInput={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
    </>
  );
};

export default Announcements;
